import api from "./api";

export const authService = {
  login: async (username, password) => {
    try {
      const response = await api.post("/auth/login", { username, password });

      console.log("[Auth] Login exitoso");
      if (response.data.previous_session_closed) {
        console.warn(
          "[Auth Security] Sesión anterior cerrada automáticamente para forzar sesión única",
        );
        console.warn(
          "[Auth Security] Dispositivo anterior:",
          response.data.previous_session?.device_name,
        );
      }

      if (response.data.token) {
        // Limpiar flag de redirección pendiente ANTES de establecer sesión nueva
        sessionStorage.removeItem("redirecting_to_login");
        sessionStorage.setItem("token", response.data.token);
        sessionStorage.setItem("user", JSON.stringify(response.data.user));
        sessionStorage.setItem("session_id", response.data.session_id);
        sessionStorage.setItem(
          "device_info",
          JSON.stringify(response.data.device),
        );
        sessionStorage.setItem(
          "previous_session_closed",
          response.data.previous_session_closed || false,
        );
      }

      return response.data;
    } catch (error) {
      console.error("[Auth] Error en login:", error.message);
      throw error;
    }
  },

  logout: async () => {
    try {
      const token = sessionStorage.getItem("token");
      if (token) {
        await api.post("/auth/logout", {}, { headers: { Authorization: `Bearer ${token}` } })
          .catch((err) => console.warn("[Auth] Logout backend falló:", err.message));
      }
    } catch (error) {
      console.warn("[Auth] Error en logout:", error.message);
    } finally {
      // Siempre limpiar sessionStorage y localStorage legacy
      authService.clearAuthData();
    }
  },

  // Limpiar todos los datos de sesión del almacenamiento
  clearAuthData: () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("session_id");
    sessionStorage.removeItem("device_info");
    sessionStorage.removeItem("previous_session_closed");
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("session_id");
    localStorage.removeItem("device_info");
    localStorage.removeItem("previous_session_closed");
  },

  getCurrentUser: () => {
    const user = sessionStorage.getItem("user");
    return user ? JSON.parse(user) : null;
  },

  isAuthenticated: () => {
    return !!sessionStorage.getItem("token");
  },

  // 🔐 SEGURIDAD: Obtener sesiones activas
  getActiveSessions: async () => {
    try {
      const token = sessionStorage.getItem("token");
      if (!token) return null;

      const response = await api.get("/auth/get-sessions", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      console.error("[Auth] Error obteniendo sesiones:", error.message);
      return null;
    }
  },

  // 🔐 SEGURIDAD: Obtener dispositivos registrados
  getRegisteredDevices: async () => {
    try {
      const token = sessionStorage.getItem("token");
      if (!token) return null;

      const response = await api.get("/auth/get-devices", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      console.error("[Auth] Error obteniendo dispositivos:", error.message);
      return null;
    }
  },

  // 🔐 SEGURIDAD: Validar que sesión está activa (detectar cierre remoto)
  validateSession: async () => {
    try {
      const token = sessionStorage.getItem("token");
      if (!token) return false;

      const response = await api.get("/auth/get-sessions", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data.count === 0) {
        console.warn("[Auth Security] Sesión ha sido cerrada");
        return false;
      }

      return true;
    } catch (error) {
      console.warn("[Auth Security] Error validando sesión:", error.message);
      if (error.response?.status === 401) {
        return false; // Sesión inválida/expirada
      }
      return true; // Asumir que está bien si hay error de red
    }
  },

  checkEmail: async (email) => {
    const response = await api.post("/auth/check-email", { email });
    return response.data;
  },

  resetPassword: async (email) => {
    try {
      const response = await api.post("/auth/request-reset", { email });
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.message || "Error al enviar correo",
      );
    }
  },

  confirmResetPassword: async (token, newPassword) => {
    try {
      const response = await api.post("/auth/reset-password", {
        token,
        password: newPassword,
      });
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.message || "Error al cambiar la contraseña",
      );
    }
  },

  changePassword: async (oldPassword, newPassword) => {
    return await api.post("/auth/change-password", {
      oldPassword,
      newPassword,
    });
  },
};
